<div class="onset-indicator d-flex justify-content-between" style="align-items: center">
  <div>
    @for (indicator of indicators; track indicator; let i = $index) {
      <button
        class="btn button-indicator"
        [ngClass]="{ done: i < currentExerciseNumber() - 1 || testDone(), current: i === currentExerciseNumber() - 1 }">
        {{ indicator }}
      </button>
    }
  </div>
  @if (displayLogo()) {
    <div>
      <img [alt]="'GAST-ONSET-NG.EXERCISE_INDICATOR.LOGO' | translate" style="max-width: 100px" [src]="cTestLogo()" />
    </div>
  }
</div>
